import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PromoSellerPicker = ({ formData, setFormData, sellers: given, testPrefix = 'promo' }) => {
  const [loaded, setLoaded] = useState([]);
  useEffect(() => {
    if (!given) axios.get(`${API}/sellers`, { withCredentials: true }).then(r => setLoaded(r.data || [])).catch(() => {});
  }, [given]);
  const list = (given || loaded).filter(s => !s.is_local && s.active !== false);
  const ids = formData.promo_allowed_seller_ids || [];
  const toggle = (id, on) => setFormData({ ...formData, promo_allowed_seller_ids: on ? [...ids, id] : ids.filter(x => x !== id) });

  return (
    <div className="border-t pt-3">
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" className="h-4 w-4" checked={!!formData.promo_seller_restricted}
          onChange={(e) => setFormData({ ...formData, promo_seller_restricted: e.target.checked })} data-testid={`${testPrefix}-seller-restricted`} />
        <span className="text-sm font-semibold">Solo aplica para ciertos vendedores</span>
      </label>
      {formData.promo_seller_restricted && (
        <div className="mt-2 border border-slate-200 rounded-lg p-2 max-h-40 overflow-y-auto space-y-1">
          {list.map(s => (
            <label key={s.id} className="flex items-center gap-2 text-sm cursor-pointer hover:bg-slate-50 px-1 py-0.5 rounded">
              <input type="checkbox" checked={ids.includes(s.id)} onChange={(e) => toggle(s.id, e.target.checked)} data-testid={`${testPrefix}-seller-${s.id}`} />
              <span>{s.name}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
